import React, { cloneElement, ReactElement, useState } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle, CModalFooter } from '@coreui/react';
import './popup.scss';

interface IPopupProps {
  children?: ReactElement | ReactElement[] | null;
  title: string;
  button: any;
  footerButton: any;
}

export const Popup: React.FunctionComponent<IPopupProps> = ({
  children,
  title,
  button,
  footerButton,
}) => {
  const [show, setShow] = useState(false);
  return (
    <>
      { cloneElement( button, { onClick: () => setShow(true) } ) }
      <CModal
        className="custom-popup"
        show={show}
        onClose={() => setShow(false)}
      >
        <CModalHeader closeButton>
          <CModalTitle>{title}</CModalTitle>
        </CModalHeader>
        <CModalBody className="popup-content">
          {children}
        </CModalBody>
        <CModalFooter>
          { cloneElement( footerButton, { onClick: () => setShow(false) } ) }
        </CModalFooter>
      </CModal>
    </>
  )
};
